import React, { useEffect, useState } from "react";
import "./CustomSelect.css";
import { useField } from "formik";
import Select from "react-select";
import select_arrow from "../../images/icons/select_arrow.png";
import dropdown_arrow from "../../images/icons/dropdown_arrow.png";

const CustomSelect = (props) => {
  const [field, meta, helpers] = useField(props);
  const hasError = meta.touched && meta.error;
  const { value } = meta;
  const [arrowIcon, setArrowIcon] = useState("");

  useEffect(() => {
    if (props.from && props.from == "noti_select") {
      setArrowIcon(dropdown_arrow);
    } else {
      setArrowIcon(select_arrow);
    }
  }, [props]);

  return (
    <div className={`customSelect ${hasError && "customSelect--has_error"}`}>
      {!props.hintText && props.label && (
        <label
          htmlFor={props.name}
          style={{ color: props.labelColor }}
          className={props.fontStyle ? props.fontStyle : ""}
        >
          {props.label}
        </label>
      )}
      {props.hintText && props.label && (
        <label style={{ color: props.labelColor }} htmlFor={props.name}>
          {props.label}{" "}
        </label>
      )}
      <Select
        // menuIsOpen={true}
        components={{
          DropdownIndicator: () => {
            return (
              <img src={arrowIcon} className="arrow_icon" alt="arrow_icon" />
            );
          },
        }}
        ref={props.refSelect}
        isClearable={props.isClearable}
        isMulti={props.isMulti}
        closeMenuOnSelect={true}
        options={props.options}
        // {...field}
        // defaultInputValue={field.value}
        isDisabled={props.disabled}
        {...props}
        // value={props.defaultValue}
        maxContent={props.maxContent}
        onBlur={() => {
          if (!meta.touched) {
            helpers.setTouched(true);
          }
        }}
        colorCode={props.colorCode}
        isSearchable={props.searchableEnabled}
        isMaxWidth={props.maxContent}
        // defaultValue={props.value}
        value={
          value !== undefined && value !== null ? props.options.find((option) => option.value === meta.value)
            : ""
        }
        onChange={(e) => {
          let value = e;
          helpers.setValue(value ? value.value : "");
          if (props.onChange) props.onChange(value);
        }}
        placeholder={props.placeholder}
      />

      {hasError ? (
        <div className="customSelect__error_text">
          {props.customErrorLabel || meta.error}
        </div>
      ) : null}
    </div>
  );
};

export default CustomSelect;
